import { DialogTrigger, Dialog, Modal } from 'react-aria-components';

import Button from '@/components/Button/Button';
import { PerformanceRecord } from '@/types/performanceRecord';

type Props = {
  isOpen: boolean;
  setIsOpen: (isOpen: boolean) => void;
  performanceRecord: PerformanceRecord;
};

export const ReasonDialog = ({ isOpen, setIsOpen, performanceRecord }: Props) => {
  return (
    <DialogTrigger
      isOpen={isOpen}
      onOpenChange={() => setIsOpen(false)}
    >
      <Modal className="fixed inset-0 z-50 flex items-center justify-center bg-black/50">
        <Dialog className="w-[600px] rounded-lg border border-gray-400 bg-white p-6 shadow-lg outline-none">
          <div className="flex flex-row gap-4">
            <span>{performanceRecord.rejection_reason}</span>
          </div>
          <div className="mt-10 flex flex-row items-center justify-center space-x-2">
            <Button
              type="button"
              size="lg"
              variant="outline"
              onClick={() => setIsOpen(false)}
            >
              戻る
            </Button>
          </div>
        </Dialog>
      </Modal>
    </DialogTrigger>
  );
};
